import { useContext } from 'react'

import { addIndexToRemove, mountBreadcrumb } from 'commons/customHooks/useBreadcrumbs'
import { Icon, TextButton } from 'components'
import { DataBreadcrumb } from 'store/BreadcrumbContext/Breadcrumb'
import { theme } from 'styles/theme/hav-theme'

import { BreadcrumbsStyled } from './styles'

export type Route = {
  path: string
  label: string
  active?: boolean
}

export const Breadcrumb: React.FC = () => {
  const breadcrumbContext = useContext(DataBreadcrumb)
  const routes = mountBreadcrumb(breadcrumbContext.items)
  const abbreviate = routes.length > 4

  return routes.length >= 1 ? (
    <BreadcrumbsStyled
      data-testid="breadcrumb"
      id="BreadcrumbRoute"
      separator={<Icon color={theme.colors.neutral.light} icon="chevron-right" size="16" />}
    >
      {routes.crumbs.map((route, index) => {
        if (abbreviate && index > 1 && index < routes.length - 2) return
        if (abbreviate && index === routes.length - 2)
          return (
            <TextButton
              key={`text-button-${index}`}
              onClick={(event) => addIndexToRemove(event.target, breadcrumbContext)}
              url={route.path}
            >
              ...
            </TextButton>
          )
        return (
          <div
            data-index={index}
            key={`external-div-${index}`}
            onClick={(event) => addIndexToRemove(event.target, breadcrumbContext)}
          >
            {route.active ? (
              <span data-test={0} id="actual-route" key={`span-${index}`}>
                {route.label}
              </span>
            ) : (
              <TextButton key={`text-button-${index}`} url={route.path}>
                {route.label.toLocaleLowerCase() === 'home' ? 'Início' : route.label}
              </TextButton>
            )}
          </div>
        )
      })}
    </BreadcrumbsStyled>
  ) : (
    <></>
  )
}
